import { FuelCallout, FuelTypography } from '@frete.com/fuel-react';
import React, { FC } from 'react';

export const UnofficalPhoneCallout: FC = () => (
  <FuelCallout
    color="orange"
    icon="alert"
    heading="Atenção! Esse telefone não é o número oficial do motorista"
    fullWidth
    iconShape
  >
    <FuelTypography slot="content" size="caption">
      Você optou por seguir mesmo assim com a GR.{' '}
      <FuelTypography displayInline weight="bold" color="inherit" size="caption">
        Cuidado isso pode ser um golpe!
      </FuelTypography>
    </FuelTypography>
  </FuelCallout>
);
